import { BrandingProvider } from '@/components/branding-provider';
import { queryClient } from '@/lib/query-client';
import { router } from '@/router/router';
import { Skeleton, Toaster } from '@ominiflow/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Suspense } from 'react';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <Suspense
          fallback={
            <div className="flex h-screen w-screen items-center justify-center">
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
        <Toaster
          position="top-right"
          toastOptions={{
            classNames: {
              toast:
                'bg-card border border-border text-foreground shadow-lg rounded-xl text-sm font-medium',
              title: 'font-semibold',
              description: 'text-muted-foreground text-xs',
              actionButton: 'bg-primary text-primary-foreground rounded-md px-3 py-1 text-xs',
              cancelButton: 'bg-muted text-muted-foreground rounded-md px-3 py-1 text-xs',
              error: 'border-destructive/30 bg-destructive/5 text-destructive',
              success: 'border-emerald-500/30 bg-emerald-500/5 text-emerald-600',
              warning: 'border-amber-500/30 bg-amber-500/5 text-amber-600',
              info: 'border-primary/30 bg-primary/5 text-primary',
            },
          }}
          expand
          richColors={false}
        />
      </BrandingProvider>
    </QueryClientProvider>
  );
}
